module.exports = __webpack_public_path__ + "assets/img/mecha3-f627606f.jpg";